import React from "react";

const SvgCrossBlack = props => <svg fill="none" viewBox="0 0 15 16" {...props}><path d="M13.86 2l-12 12M1.86 2l12 12" stroke="#000" strokeWidth={1.5} strokeLinecap="square" /></svg>;

export default "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxNSAxNiI+PHBhdGggZD0iTTEzLjg2IDJsLTEyIDEyTTEuODYgMmwxMiAxMiIgc3Ryb2tlPSIjMDAwIiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InNxdWFyZSIvPjwvc3ZnPg==";
export { SvgCrossBlack as ReactComponent };